import BasePage from "@Scripts/Pages/BasePage";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class CheckoutConfirmPage extends BasePage {
    public static async init() {
        await super.init();

        var itemList = [];

        for (var i = 0; i < (<any>window).App.bag.order.rows.length; i++) {
            itemList.push({
                item_id: (<any>window).App.bag.order.rows[i].productCode,
                item_name: (<any>window).App.bag.order.rows[i].productTitle,
                affiliation: "Technical Ceramic",
                currency: "EUR",
                item_category: (<any>window).App.bag.order.rows[i].categoryName,
                price: (<any>window).App.bag.order.rows[i].unitPrice,
                quantity: (<any>window).App.bag.order.rows[i].quantity
            });
        }

        GTagHelper.sendCustomEvent("purchase", {
            currency: "EUR",
            transaction_id: (<any>window).App.bag.order.orderCode,
            value: (<any>window).App.bag.order.orderTotal,
            coupon: (<any>window).App.bag.order.couponCode,
            shipping: (<any>window).App.bag.order.shippingCosts,
            items: itemList
        });
    }
}